import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { SettingsService } from '@app/core/settings/settings.service';
import { publishLast, refCount } from 'rxjs/operators';
import { LoginV2CommonService } from '../../login-v2-common.service';
import { getIdentifier } from '@app/+login/deprecated-hybrid/helpers';
import { IdentifierType, MemberIdentifier } from '@app/core/_models/member-interface';
import { Subscription } from 'rxjs';


const INCORRECT_PHONE_NUMBER_KEY = 'phone_number_incorrect';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class PhoneConfirmationAbstractComponent implements OnInit, OnDestroy {
  public abstract headerTitleKey: string;
  public abstract otherMethodKey: string;
  public abstract pageType: 'login' | 'signup';
  public settingsObservable = this.settingsService.getSettingsOnce().pipe(publishLast(), refCount());
  public formControl = new UntypedFormControl('', { updateOn: 'change' });
  public formErrors: { error?: string; [key: string]: unknown } = {};
  private formControlSub: Subscription;

  protected constructor(protected router: Router, protected route: ActivatedRoute, protected common: LoginV2CommonService,
                        private settingsService: SettingsService, protected cdr: ChangeDetectorRef) { }

  public abstract onNext(): void;

  public abstract navigateToOtherMethod(): void;

  public ngOnInit(): void {
    this.formControlSub = this.formControl.valueChanges.subscribe(() => this.onFormControlValueChange());
    this.setupStateData();
  }

  public ngOnDestroy(): void {
    this.formControlSub?.unsubscribe();
  }

  protected currentMsisdnIdentifier(): MemberIdentifier {
    return getIdentifier(this.formControl.value, IdentifierType.MSISDN);
  }

  protected setFormControlError(error: string, detectChanges = true): void {
    this.formErrors = { error: error };
    if (detectChanges) { this.cdr.detectChanges(); }
  }

  protected onFormControlValueChange(): void {
    this.formErrors = {}; // reset errors
    if (!this.formControl.valid) { this.setFormControlError(INCORRECT_PHONE_NUMBER_KEY, false); }
    this.cdr.detectChanges();
  }

  private setupStateData(): void {
    const { state } = history;
    const { identifier } = state;

    // return to login page when page opened manually
    if (!identifier) {
      this.router.navigate(['..'], { relativeTo: this.route });
      return;
    }

    this.formControl.setValue(identifier.identifier);
  }
}
